import ButtonToggleTime from 'app/ui/buttons/ButtonToggleTime';
import ButtonHome from 'app/ui/buttons/ButtonHome';
import OverlayMacroView from 'app/ui/OverlayMacroView';
import ButtonHelp from './buttons/ButtonHelp';
// import ButtonSimple from './buttons/ButtonSimple';
import HoverGauge from './HoverGauge';
import DragHint from './DragHint';
import ButtonArrow from './buttons/ButtonArrow';

export default class GameHud extends Phaser.Group {
  constructor(game, state) {
    super(game);

    this.state = state; // reference to Campout state
    this.dragHintId = 44;

    this.game.scale.onSizeChange.add(this.positionContainer, this);

    this.onShowHint = new Phaser.Signal();
    this.onScrollLeft = new Phaser.Signal();
    this.onScrollRight = new Phaser.Signal();

    //
    this.btnHome = new ButtonHome({
      game: this.game,
      up: 'btn_reset',
      over: 'btn_reset',
      pressed: 'btn_reset_pressed',
    });
    this.btnHome.x = 75;
    this.btnHome.y = 75;
    this.btnHome.onPressed.add(this.handleBtnHome, this);
    this.addChild(this.btnHome);

    //
    this.btnHelp = new ButtonHelp(this.game, this.state);
    this.btnHelp.x = 80;
    this.btnHelp.y = this.game.defaultHeight - 20;
    this.btnHelp.onSelect.add(this.handleBtnHelp, this);
    this.addChild(this.btnHelp);

    //
    this.onToggleTime = new Phaser.Signal();
    this.btnToggleTime = new ButtonToggleTime(this.game);
    this.btnToggleTime.x = 80;
    this.btnToggleTime.y = 93;
    this.btnToggleTime.onToggle.add(this.handleToggleTime, this);
    this.addChild(this.btnToggleTime);

    //
    this.createScrollArrows();
    this.hideScrollArrows(false);

    //
    this.positionContainer();
  }

  lock() {
    this.btnHelp.disable();
    this.btnToggleTime.disable();
  }

  unlock() {
    this.btnHelp.enable();
    this.btnToggleTime.enable();
  }

  handleBtnHome() {
    this.game.controller.showWelcomeScreen(true);
  }

  handleBtnHelp() {
    this.onShowHint.dispatch();
  }

  handleToggleTime(dayTime) {
    this.onToggleTime.dispatch(dayTime);
  }

  positionContainer() {
    this.btnHelp.x =
      this.game.width - (this.game.deviceMetric.platform.type === 'smartphone' ? 100 : 80);
    this.btnToggleTime.x = this.game.width * 0.5;

    if (this.macroView) {
      this.macroView.positionElements();
    }

    if (this.btnRight) {
      this.btnRight.x = this.game.width - 43;
    }
  }

  showMacroView({ x, y, macroView, furniture, animInd }) {
    this.macroView = new OverlayMacroView({ game: this.game, x, y, macroView, furniture, animInd });
    this.addChild(this.macroView);
    this.macroView.onClose.addOnce(this.handleMacroViewClose, this);
  }

  handleMacroViewClose() {
    this.macroView.onClose.remove(this.handleMacroViewClose, this);
    this.macroView.destroy();
    this.macroView = null;
  }

  //
  showHoverGauge(x, y) {
    if (!this.hoverGauge) {
      this.hoverGauge = new HoverGauge(this.game, x, y);
      this.addChild(this.hoverGauge);
    } else {
      this.hoverGauge.visible = true;
      this.hoverGauge.x = x;
      this.hoverGauge.y = y;
      this.setHoverValue(0);
    }

    this.hoverGauge.show();
  }

  hideHoverGauge() {
    this.hoverGauge.hide();
  }

  setHoverValue(value) {
    this.hoverGauge.setValue(value);
  }

  //
  showDragHint(playVO = true) {
    this.dragHint = new DragHint(this.game, 130, 360, this.dragHintId, this, playVO);
    this.addChild(this.dragHint);

    this.dragHintId = this.dragHintId === 44 ? 45 : 44;
  }

  hideDragHint() {
    this.dragHint = null;
    this.state.resetCameraTimer();
  }

  removeDragHint() {
    if (this.dragHint) {
      this.dragHint.destroy();
      this.dragHint = null;
    }
  }

  // ---------------------------------------------------------------------------
  // scroll arrows
  // ---------------------------------------------------------------------------
  createScrollArrows() {
    this.arrowsContainer = this.game.make.group();
    this.addChild(this.arrowsContainer);

    this.btnLeft = new ButtonArrow({
      game: this.game,
      up: 'arrow_left',
      down: 'arrow_left',
    });
    this.arrowsContainer.addChild(this.btnLeft);
    this.btnLeft.x = 43;
    this.btnLeft.y = this.game.height * 0.5;
    this.btnLeft.onInputDown.add(this.handleBtnLeftInputDown, this);

    this.btnRight = new ButtonArrow({
      game: this.game,
      up: 'arrow_right',
      down: 'arrow_right',
    });
    this.arrowsContainer.addChild(this.btnRight);
    this.btnRight.x = this.game.width - 43;
    this.btnRight.y = this.game.height * 0.5;
    this.btnRight.onInputDown.add(this.handleBtnRightInputDown, this);
  }

  showScrollArrows(showLeft = true, showRight = true) {
    this.btnLeft.setVisibility(showLeft);
    this.btnRight.setVisibility(showRight);
  }

  hideScrollArrows(visibility = true) {
    if (visibility) {
      this.btnLeft.visible = false;
      this.btnRight.visible = false;
    }
    this.btnLeft.hide(true);
    this.btnRight.hide(true);
  }

  unhideScrollArrows() {
    this.btnLeft.visible = true;
    this.btnRight.visible = true;
  }

  lockArrows() {
    this.arrowsLocked = true;
    this.btnLeft.input.enabled = false;
    this.btnRight.input.enabled = false;
  }

  unlockArrows() {
    this.arrowsLocked = false;
    this.btnLeft.input.enabled = true;
    this.btnRight.input.enabled = true;
  }

  handleBtnLeftInputDown() {
    this.onScrollLeft.dispatch();
  }

  handleBtnRightInputDown() {
    this.onScrollRight.dispatch();
  }

  //
  // eslint-disable-next-line max-statements
  destroy(destroyChildren = true, soft) {
    this.game.scale.onSizeChange.remove(this.positionContainer, this);
    super.destroy(destroyChildren, soft);
  }
}
